export default {
  clear: {
    id: 'outlet_filter_bar_clear',
    defaultMessage: 'Clear',
  },
  seeResults: {
    id: 'outlet_filter_bar_see_results',
    defaultMessage: `See {count, plural,
      one {# result}
      other {# results}
    }`,
  },
  rangeMin: {
    id: 'outlet_filter_bar_range_min',
    defaultMessage: 'Min',
  },
  rangeMax: {
    id: 'outlet_filter_bar_range_max',
    defaultMessage: 'Max',
  },

  facetPrice: {
    id: 'outlet_filter_bar_facet_price',
    defaultMessage: 'Price',
  },
  facetCondition: {
    id: 'outlet_filter_bar_facet_condition',
    defaultMessage: 'Condition',
  },
  facetModel: {
    id: 'outlet_filter_bar_facet_model',
    defaultMessage: 'Model',
  },
  facetReleaseYear: {
    id: 'outlet_filter_bar_facet_release_year',
    defaultMessage: 'Release year',
  },
  facetStorage: {
    id: 'outlet_filter_bar_facet_storage',
    defaultMessage: 'Storage',
  },
  facetScreenSize: {
    id: 'outlet_filter_bar_facet_screen_size',
    defaultMessage: 'Screen size',
  },
  facetColor: {
    id: 'outlet_filter_bar_facet_color',
    defaultMessage: 'Color',
  },
  facetMemory: {
    id: 'outlet_filter_bar_facet_memory',
    defaultMessage: 'Memory',
  },
  facetProcessor: {
    id: 'outlet_filter_bar_facet_processor',
    defaultMessage: 'Processor',
  },
  facetKeyboardLanguage: {
    id: 'outlet_filter_bar_facet_keyboard_language',
    defaultMessage: 'Keyboard language',
  },
}
